import { canadaRegex, quebecRegex, usRegex } from '@/components/Inputs/Date/DateValidation';
import { compareDesc, format, parse, subDays, subYears } from 'date-fns';

export const inputFormat = (canada: boolean, quebec: boolean) => {
  switch (true) {
    case canada && !quebec:
      return 'yyyyMMdd';
    case quebec:
      return 'ddMMyyyy';
    default:
      break;
  }
  return 'MMddyyyy';
};
export const validDate = (value: string) => {
  if (value.length !== 8) {
    return false;
  }
  return !!(value.match(usRegex) ?? value.match(canadaRegex) ?? value.match(quebecRegex));
};

export const dateLessThan15DayOldOrInFuture =
  (canada: boolean, quebec: boolean) => (value: string) => {
    if (!value || !validDate(value)) {
      return true;
    }

    const max = subDays(new Date(), 15);
    const tdate = parse(value, inputFormat(canada, quebec), new Date());
    // This is being added per D-03305 where if date is in future instead of showing
    // Child must at least 15 days old, we will show invalid message instead
    return tdate <= max;
  };

export const minDateNonNextGen = (canada: boolean, quebec: boolean) => (value: string) => {
  if (!value || !validDate(value)) {
    return true;
  }
  const min = subYears(new Date(), 24.5);
  const tdate = parse(value, inputFormat(canada, quebec), new Date());
  return tdate > min;
};

export const minDateNextGen = (canada: boolean, quebec: boolean) => (value: string) => {
  if (!value || !validDate(value)) {
    return true;
  }
  const min = subYears(new Date(), 17.5);
  const tdate = parse(value, inputFormat(canada, quebec), new Date());
  return tdate > min;
};

// TODO: This is not being used
export const maxDate = (canada: boolean, quebec: boolean) => (value: string) => {
  if (!value || !validDate(value)) {
    return true;
  }
  const tdate = parse(value, inputFormat(canada, quebec), new Date());
  const max = subDays(new Date(), 15);
  const now = new Date();
  // This is being added per D-03305 where if date is in future instead of showing
  // Child must at least 15 days old, we will show invalid message instead
  if (tdate > now) {
    return true;
  }

  return tdate < max;
};

export const dateBetween18And100 = (canada: boolean, quebec: boolean) => (value: string | null) => {
  // return false shows error on front end
  // Checking for null, undefined or empty value if so return false
  if (!value) {
    return false;
  }
  let regex = usRegex;
  if (canada) {
    regex = canadaRegex;
  }
  if (quebec) {
    regex = quebecRegex;
  }
  const match = value.match(regex);
  // if value doesn't match the regex match will be null so !!(match) will be false
  if (!match) {
    return false;
  }
  const tdate = parse(value, inputFormat(canada, quebec), new Date());
  const min = subYears(new Date(), 18);
  const max = subDays(subYears(new Date(), 100), 1);
  // date entered is before 100 years or after 18 years i.e less than 18 years return false
  if (tdate < max || tdate >= min) {
    return false;
  }
  return true;
};

export const bornOnOrAfterIssue =
  (issueDate: string, canada: boolean, quebec: boolean) => (value: string) => {
    if (!issueDate || !value || !validDate(value)) {
      return true;
    }
    const date = parse(value, inputFormat(canada, quebec), new Date());
    const issued = parse(issueDate, 'MM/dd/yyyy', new Date());
    return compareDesc(issued, date) >= 0;
  };

export const formatFromUS = (date: string) => {
  return format(new Date(date), 'yyyy-MM-dd');
};

export const formatFromCA = (date: string) => {
  return format(new Date(date), 'yyyy-MM-dd');
};

export const formatFromQuebec = (date: string) => {
  return format(new Date(date), 'yyyy-MM-dd');
};
